import DialogTrophies from '~/components/dialog/trophies/DialogTrophies.vue';
import { getServices } from '~/db/services';

export const useDialogTrophyFromHeader = () => {
  const { $db } = useNuxtApp();

  const { trophiesService, mediasService } = getServices($db);

  const dialog = useDialogStore();

  const { t } = useNuxtApp().$i18n;

  const mediaLoader = useMediaLoader();

  const open = async (ids: string[]) => {
    // trophies
    const trophies = await trophiesService.findByIds(ids);
    if (!trophies?.length) return;
    // associated medias
    const mediaIds = trophies.map((trophy) => trophy.icon);
    mediaLoader.addIds(mediaIds);
    const medias = await mediaLoader.retrieveAll();
    await openDialog(trophies, medias);
    // update collection
    const trophiesUpdated = trophies.map((trophy) => ({
      ...trophy,
      ratioProgress: 1,
    }));
    await trophiesService.bulkUpdate(trophiesUpdated);
  };

  const openDialog = async (
    trophies: TrophySchema[],
    medias: Map<string, MediaSchema>
  ) => {
    return new Promise<void>((resolve) => {
      dialog.open(DialogTrophies, {
        trophies,
        medias,
        onClose: () => {
          resolve();
        },
      });
    });
  };
  return {
    open,
  };
};
